import { render, staticRenderFns } from "./clothSheetDetail.vue?vue&type=template&id=01a52f38&scoped=true"
import script from "./clothSheetDetail.vue?vue&type=script&lang=js"
export * from "./clothSheetDetail.vue?vue&type=script&lang=js"
import style0 from "./clothSheetDetail.vue?vue&type=style&index=0&id=01a52f38&prod&lang=scss&scoped=true"
import style1 from "./clothSheetDetail.vue?vue&type=style&index=1&id=01a52f38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a52f38",
  null
  
)

export default component.exports